import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { ref, watch, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from "vue-router";
import "vant/lib/index.css";
import bus from "@/lib/bus";
import { getWarehouseNewProduct } from "@/api/api";
import { reloadSDK } from "@/utils/utils";
import { platformStore } from "@/store/index";
import { reloadLanguagePack } from "@/lang/i18n";
import tracking from "@/utils/tracking";
export default {
  props: ["token"],
  setup(props, context) {
    const store = platformStore();
    const isTabbar = ref(1);
    const type = ref(1); //1未登录2已登录
    const showList = ref(false); //菜单弹窗状态
    const mobile = ref("");
    const showTabrList = () => {
      showList.value = !showList.value;
    };
    // 注销
    const showLogin = () => {
      if (type.value == 2) {
        store.setAccessToken("");
        type.value = 1;
        store.setMobile("");
        mobile.value = "";
        bus.$emit("clear");
      }
      showList.value = false;
      context.emit("showLogin");
    };
    // 登录状态
    const tokenType = props;
    watch(tokenType, newValue => {
      if (newValue) {
        type.value = 2;
        mobile.value = store.mobile;
      }
    });
    // 前往官方充值页面
    const route = useRouter();
    const goPayPage = () => {
      showList.value = false;
      isTabbar.value = 1;
      route.push({
        path: "/"
      });
    };

    // 前往订单页面
    const goOrderPage = () => {
      showList.value = false;
      if (!store.access_token) {
        bus.$emit("click");
        return;
      }
      isTabbar.value = 2;
      route.push({
        path: "/orderpage"
      });
    };
    const goHomePage = () => {
      route.push({
        path: "/"
      });
    };
    const goJfSC = () => {
      showList.value = false;
      isTabbar.value = 3;
      route.push({
        path: "/pointmall"
      });
    };
    document.getElementsByClassName("top-list");
    bus.$on("changeTab", e => {
      isTabbar.value = e;
    });
    bus.$on("login", () => {
      type.value = 2;
      console.log(store.mobile);
      mobile.value = store.mobile;
    });
    // 打开客服页面
    const openKf = () => {
      showList.value = false;
      if (!store.access_token) {
        bus.$emit("click");
        return;
      }
      bus.$emit("showKf");
    };
    const kfUrl = computed(() => store.kfUrl);
    const positionType = ref("right");
    const isPwa = computed(() => store.isPwa);
    onMounted(() => {
      if (store.access_token) {
        type.value = 2;
        mobile.value = store.mobile;
        getDetailList();
      }
      //是否展示引导添加到主屏幕的弹窗的按钮
      // 是否为pc端
      if (window.innerWidth > 768) {
        positionType.value = "top";
      }

      // 初始化语言选择器
      initLanguageSelector();

      // 监听语言配置变化
      watchLanguageConfig();

      // 监听点击事件，点击外部关闭下拉框
      document.addEventListener("click", closeLangDropdown);

      // 监听语言列表更新事件
      bus.$on("updateLanguageList", () => {
        initLanguageSelector();
      });
    });

    /**
     * 组件卸载时清理事件监听
     */
    onUnmounted(() => {
      // 清理 bus 事件监听
      bus.$off("updateLanguageList");
      bus.$off("changeTab");
      bus.$off("login");
      bus.$off("loginOut");

      // 清理 DOM 事件监听
      document.removeEventListener("click", closeLangDropdown);
    });
    const showChecked = ref(false);
    bus.$on("loginOut", () => {
      if (type.value == 2) {
        type.value = 1;
        mobile.value = "";
      }
      context.emit("showLogin");
      store.setAccessToken("");
      store.setPointsNum(0);
      store.setLoginTask("");
      store.setMobile("");
    });
    const deskTopBtn = () => {
      tracking.trackClick({
        button: 'todesk',
        game_id: store.gameId,
        page: route.currentRoute.value.name,
        role_id: store.chooseGameList.role_id ? store.chooseGameList.role_id.toString() : '',
        server_id: store.chooseGameList.server_id ? store.chooseGameList.server_id.toString() : '',
        role_name: store.chooseGameList.role_name || ''
      });
      bus.$emit("deskTop");
    };
    const checked = ref(false);

    // 前往兑换记录页
    const goExchangePage = () => {
      showList.value = false;
      if (!store.access_token) return showLogin(); //未登录调取登录接口
      route.push({
        path: `./exchangerecord`
      });
    };
    // 积分记录跳转
    const goPointsDetail = () => {
      showList.value = false;
      if (!store.access_token) return showLogin(); //未登录调取登录接口
      route.push({
        path: `./integraldetail`
      });
    };
    // 前往我的地址
    const goAddressListPage = () => {
      showList.value = false;
      if (!store.access_token) return showLogin(); //未登录调取登录接口
      route.push({
        path: `./myaddress`
      });
    };
    // 前往仓库
    const goWarehousePage = () => {
      showList.value = false;
      if (!store.access_token) return showLogin(); //未登录调取登录接口
      route.push({
        path: `./warehousepage`
      });
    };
    // 前往周边兑换
    const goCodeExchangePage = () => {
      showList.value = false;
      if (!store.access_token) return showLogin(); //未登录调取登录接口
      route.push({
        path: `./codeexchange`
      });
    };
    const iconShow = ref(false); //仓库红点
    // 获取仓库列表
    const getDetailList = () => {
      getWarehouseNewProduct().then(res => {
        if (res.code == 200) {
          if (res.metadata.status) {
            iconShow.value = true;
          }
          store.setRedDot(!!res.metadata.status);
        }
      });
    };
    // 语言选择相关状态
    const showLangDropdown = ref(false);
    const currentLang = ref(store.lang || "zh-cn");
    const showLanguageSelector = ref(false);

    // 动态语言列表
    const languageList = ref([]);
    const initLanguageSelector = () => {
      try {
        const availableLanguages = store.availableLanguages;
        if (availableLanguages) {
          // console.log("语言列表更新:", languages)
          // 只有当语言列表长度大于1时才显示语言选择器
          if (availableLanguages && availableLanguages.length > 1) {
            showLanguageSelector.value = true;

            // 转换语言数据格式
            languageList.value = availableLanguages.map(lang => ({
              code: lang.lang_const,
              name: lang.lang_const_text,
              native: lang.lang_const || lang.native || lang.lang_name || lang.name
            }));
          } else {
            showLanguageSelector.value = false;
          }
        } else {
          showLanguageSelector.value = false;
        }
      } catch (error) {
        console.error("初始化语言选择器失败:", error);
        showLanguageSelector.value = false;
      }
    };

    /**
     * 切换语言选择下拉框显示状态
     */
    const choiceLang = () => {
      showLangDropdown.value = !showLangDropdown.value;
    };

    /**
     * 处理语言切换点击事件
     * @param {string} langCode - 语言代码
     */
    const handleLanguageChange = langCode => {
      // 如果当前语言已经是目标语言，不需要切换
      if (currentLang.value === langCode) {
        showLangDropdown.value = false;
        return;
      }

      // 异步调用语言切换方法
      changeLanguage(langCode).catch(error => {
        console.error("语言切换失败:", error);
      });
    };

    /**
     * 切换语言
     * @param {string} langCode - 语言代码
     */
    const changeLanguage = async langCode => {
      // 保存当前语言，用于错误时回滚
      const previousLang = currentLang.value;
      try {
        // 先更新本地状态和localStorage
        currentLang.value = langCode;
        store.changeLang(langCode);

        // 重新加载语言包
        await reloadLanguagePack(langCode, window.$i18n);

        // 更新i18n当前语言
        if (window.$i18n) {
          window.$i18n.locale.value = langCode;
        }

        // 关闭下拉框
        showLangDropdown.value = false;
        console.log("语言已切换到:", langCode);
        store.changeLang(langCode);
        bus.$emit("changeLangSuccess");
        reloadSDK();
      } catch (error) {
        console.error("切换语言失败:", error);
        // 如果重新加载失败，回滚到之前的语言
        currentLang.value = previousLang;
        store.changeLang(previousLang);
        if (window.$i18n) {
          window.$i18n.locale.value = previousLang;
        }
      }
    };

    /**
     * 点击外部关闭语言选择下拉框
     */
    const closeLangDropdown = event => {
      const langChoice = document.querySelector(".lang-choice");
      if (langChoice && !langChoice.contains(event.target)) {
        showLangDropdown.value = false;
      }
    };

    /**
     * 监听语言配置变化
     */
    const watchLanguageConfig = () => {
      // 保存上一次的 availableLanguages 值，用于比较变化
      let lastAvailableLanguages = store.availableLanguages;
      store.$subscribe((mutation, state) => {
        const currentAvailableLanguages = state.availableLanguages;

        // 只有当 availableLanguages 真正发生变化时才执行
        if (JSON.stringify(currentAvailableLanguages) !== JSON.stringify(lastAvailableLanguages)) {
          lastAvailableLanguages = currentAvailableLanguages;
          // 重新初始化语言选择器
          initLanguageSelector();
        }
      });
    };
    const logo = ref(store.logo);
    // 强制刷新页面
    const refreshPage = () => {
      window.location.reload(true);
    };
    return {
      store,
      isPwa,
      positionType,
      kfUrl,
      logo,
      choiceLang,
      handleLanguageChange,
      changeLanguage,
      showLangDropdown,
      languageList,
      currentLang,
      showLanguageSelector,
      iconShow,
      getDetailList,
      goWarehousePage,
      goAddressListPage,
      goExchangePage,
      goPointsDetail,
      showChecked,
      checked,
      deskTopBtn,
      goHomePage,
      mobile,
      isTabbar,
      openKf,
      goOrderPage,
      goPayPage,
      type,
      showList,
      showTabrList,
      showLogin,
      goJfSC,
      refreshPage,
      goCodeExchangePage
    };
  }
};